import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import "@/art/global.css";
import { tokens, tokensAsCssVariables } from "@/art/tokens";
import { checkAndMaybeRefreshIfStale } from "@/utils/versionCheck";

// 런타임에 :root 에 토큰 CSS 변수를 주입 — 디자인 토큰 변경 시 이 부분만 재빌드.
const rootStyle = document.documentElement.style;
for (const [key, value] of Object.entries(tokensAsCssVariables())) {
    rootStyle.setProperty(key, value);
}
void tokens;

const container = document.getElementById("root");
if (!container) throw new Error("root element missing");

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);

// 앱 mount 직후 버전 체크 — 구버전이면 자동 reload (최대 3회 가드, src/utils/versionCheck.ts).
// 렌더 블로킹 피하려고 requestIdleCallback / setTimeout fallback 으로 다음 tick 에 실행.
const scheduleVersionCheck = () => { void checkAndMaybeRefreshIfStale(); };
if (typeof (window as unknown as { requestIdleCallback?: (cb: () => void) => void }).requestIdleCallback === "function") {
    (window as unknown as { requestIdleCallback: (cb: () => void) => void })
        .requestIdleCallback(scheduleVersionCheck);
} else {
    window.setTimeout(scheduleVersionCheck, 800);
}
